"use client";

import {
  BlockquotePlugin,
  H1Plugin,
  H2Plugin,
  H3Plugin,
  H4Plugin,
  H5Plugin,
  H6Plugin,
  HorizontalRulePlugin,
} from "@platejs/basic-nodes/react";
import { BlockquoteRules, HeadingRules, HorizontalRuleRules } from "@platejs/basic-nodes";
import { ParagraphPlugin } from "platejs/react";

import { BlockquoteElement } from "../../ui/blockquote-node";
import { H1Element, H2Element, H3Element, H4Element, H5Element, H6Element } from "../../ui/heading-node";
import { HrElement } from "../../ui/hr-node";
import { ParagraphElement } from "../../ui/paragraph-node";

export const BasicBlocksKit = [
  ParagraphPlugin.withComponent(ParagraphElement),
  H1Plugin.configure({
    node: { component: H1Element },
    rules: { break: { empty: "reset" } },
    shortcuts: { toggle: { keys: "mod+alt+1" } },
    inputRules: [HeadingRules.markdown()],
  } as any),
  H2Plugin.configure({
    node: { component: H2Element },
    rules: { break: { empty: "reset" } },
    shortcuts: { toggle: { keys: "mod+alt+2" } },
    inputRules: [HeadingRules.markdown()],
  } as any),
  H3Plugin.configure({
    node: { component: H3Element },
    rules: { break: { empty: "reset" } },
    shortcuts: { toggle: { keys: "mod+alt+3" } },
    inputRules: [HeadingRules.markdown()],
  } as any),
  H4Plugin.configure({
    node: { component: H4Element },
    rules: { break: { empty: "reset" } },
    shortcuts: { toggle: { keys: "mod+alt+4" } },
    inputRules: [HeadingRules.markdown()],
  } as any),
  H5Plugin.configure({
    node: { component: H5Element },
    rules: { break: { empty: "reset" } },
    shortcuts: { toggle: { keys: "mod+alt+5" } },
    inputRules: [HeadingRules.markdown()],
  } as any),
  H6Plugin.configure({
    node: { component: H6Element },
    rules: { break: { empty: "reset" } },
    shortcuts: { toggle: { keys: "mod+alt+6" } },
    inputRules: [HeadingRules.markdown()],
  } as any),
  BlockquotePlugin.configure({
    node: { component: BlockquoteElement },
    shortcuts: { toggle: { keys: "mod+shift+period" } },
    inputRules: [BlockquoteRules.markdown()],
  } as any),
  HorizontalRulePlugin.configure({
    node: { component: HrElement },
    inputRules: [HorizontalRuleRules.markdown()],
  } as any),
];
